// Saved Cards
export const UPDATE_SAVED_CARDS = "update_saved_cards";
export const SET_UPDATE_SAVED_CARDS_LOADING = "set_update_saved_cards_loading";
export const SAGA_FETCH_SAVED_CARDS = "saga_fetch_saved_cards";

// Saved Comparisons
export const UPDATE_SAVED_COMPARISONS = "update_saved_comparisons";
export const SET_UPDATE_SAVED_COMPARISONS_LOADING = "set_update_saved_comparisons_loading";
export const SAGA_FETCH_SAVED_COMPARISONS = "saga_fetch_saved_comparisons";


//Reviews
export const GET_REVIEWS = "GET_REVIEWS";
export const GET_AUTO_SUGGESTIONS = "GET_AUTO_SUGGESTIONS";
export const SUBMIT_REVIEW = "SUBMIT_REVIEW";
export const SELECT_SUGGESTION = "SELECT_SUGGESTION"

// College
export const  GET_COLLEGE = "GET_COLLEGE";

export const  GET_VALUATOR = "GET_VALUATOR";

export const  GET_BundleNo = "GET_BundleNo";

export const  GET_BundleKey = "GET_BundleKey";

export const  GET_OmrCodes = "GET_OmrCodes";
export const  GET_MarksTable = "GET_MarksTable";

export const  GET_MarksSaving = "GET_MarksSaving";

export const  GET_CheckTotal = "GET_CheckTotal";


export const  GET_ScriptPath = "GET_ScriptPath";


export const GET_TokenUserRegister='GET_TokenUserRegister';
export const GET_UserRegister='GET_UserRegister';

export const UPDATE_MARKS_TABLE = 'UPDATE_MARKS_TABLE';

export const GET_CrystalPdf='GET_CrystalPdf';

export const GET_IpAddress='GET_IpAddress';
export const GET_AutoMarksSaving='GET_AutoMarksSaving'
export const GET_FacultyDesignation='GET_FacultyDesignation'